/**
 * Module dependencies.
 */

import { Title } from '../title/title';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `SubTitleComponent` styled component.
 */

export const SubTitleComponent = styled(Title)`
  font-size: 20px;
  color: ${color('primary500')};
  font-weight: 600;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
